<main class="app-container" [ngClass]="isProd ? 'production' : ''"
  [ngStyle]="{'background-image': 'url(' + backgroundImage + ')'}">
  @if (isUserInAviationDirectory) {
    @if (innerWidth > 767) {
      @if ((isLoggedIn$ | async)) {
        <app-nav-bar></app-nav-bar>
      }
      <div [ngClass]="(isLoggedIn$ | async) ? 'content-container-gapped' : 'content-container-filled'">
        <ng-container *ngTemplateOutlet="routeroutlet"></ng-container>
      </div>
    }
    @if (innerWidth <= 767) {
      <div class="content-container-filled is-mobile">
        <mat-sidenav-container hasBackdrop="true"
          [ngClass]="(isLoggedIn$ | async) ? 'content-mobile-container-logged-in' : 'content-mobile-container-logged-out'">
          <mat-sidenav #sidenav mode="over" fixedInViewport="true" class="side-nav">
            <app-nav-bar (toggleSideNav)="sidenav.toggle()"></app-nav-bar>
          </mat-sidenav>
          <mat-sidenav-content>
            @if (isLoggedIn$ | async) {
              <app-nav-bar-mobile (openSideNav)="sidenav.toggle()"></app-nav-bar-mobile>
            }
            <ng-container *ngTemplateOutlet="routeroutlet"></ng-container>
          </mat-sidenav-content>
        </mat-sidenav-container>
      </div>
    }
  }
  @if (!isUserInAviationDirectory) {
    @if (showSpinner) {
      <div class="loading">
        <span>Aviation Directory loading....</span>
        <mat-spinner class=" spinner"></mat-spinner>
      </div>
    }
    @if (!(isLoggedIn$ | async) && !showSpinner) {
      <div class="missingUser">
        {{missingUserMessage}}
        <br>
          <br>
            {{missingUserMessage2}}
            <br>
              <br>
                <a class="missingUserLinkColor" href="{{missingUserLink}}">{{missingUserLinkText}}</a>
              </div>
            }
          }
          <!-- https://stackoverflow.com/questions/60337030/angular-router-outlet-does-not-work-after-resize-of-window -->
        </main>
        <ng-template #routeroutlet>
          <router-outlet></router-outlet>
        </ng-template>

        @if (!isProd) {
          <status-bar></status-bar>
        }
